import React, { useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { Button } from 'components/Button';
import Model from '../../../../model';

import './index.sass';

const { block } = bem('pay-button');
const PayButton = ({ item }) => {

    const { openOfficePayPurchaseForm } = Model.modal;
    const { price, pk, isDigital } = item;

    const url = isDigital ? '/digital/pay' : '/loot/pay';

    const clickHandler = useCallback(() => {
        openOfficePayPurchaseForm({url, price, pk, isDigital});
    }, [ item ]);

    return (
        <div className={ block() } onClick={ clickHandler }>
            <Button mod={ 'gold' }><Text>Оплатить</Text></Button>
        </div>
    );
};

export default PayButton;
